import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-repeat",
  "use": "icon-repeat-usage",
  "viewBox": "0 0 49 48",
  "content": "<symbol viewBox=\"0 0 49 48\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-repeat\"><path d=\"M14.6923 43.1153L7.3847 35.8077L14.6923 28.5001L16.2923 30.1616L11.7808 34.6731H35.5384V26.6731H37.8076V36.9423H11.7808L16.2923 41.4538L14.6923 43.1153ZM11.1924 21.3269V11.0578H37.2193L32.7077 6.5462L34.3077 4.8847L41.6153 12.1923L34.3077 19.5L32.7077 17.8385L37.2193 13.3269H13.4616V21.3269H11.1924Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol